import React, { useState, useEffect } from "react";
import TopHeader from "./subcomponents/TopHeader";
import { Box, Paper, Typography, Button, Slide, Card, CardContent,Switch } from "@mui/material";
import { TextField, Container, List,ListItem,ListItemText,Chip,ListItemIcon,Divider } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useLocation } from "react-router-dom";
import { 
    CalendarMonth, 
    AccessTime, 
    Person, 
    Save, 
    Check, 
    EventAvailable,
    People,
    CenterFocusStrong
  } from '@mui/icons-material';
function Appointments() {
  const [isFamilyAppointment,setIsFamilyAppointment] = useState(false)
  const [patientIds,setPatientIds] = useState([])
  const [patientApptIds,setPatientApptIds] = useState([])
  const [appointments, setAppointments] = useState([ {
    firstName: "Michael",
    lastName: "Johnson",
    preferredName: "Mike",
    appointmentDate: "2025-04-05",
    appointmentTime: "10:15:00"
  }]);
 // Example data - single patient
 const singlePatientData = [
    {
      firstName: "John",
      lastName: "Smith",
      preferredName: "Johnny",
      appointmentDate: "2025-04-02",
      appointmentTime: "14:30:00"
    }
  ];

  // Example data - family appointment
  const familyAppointmentData = [
    {
      firstName: "Michael",
      lastName: "Johnson",
      preferredName: "Mike",
      appointmentDate: "2025-04-05",
      appointmentTime: "10:15:00"
    },
    {
      firstName: "Sarah",
      lastName: "Johnson",
      preferredName: "",
      appointmentDate: "2025-04-05",
      appointmentTime: "10:15:00"
    },
    {
      firstName: "Emma",
      lastName: "Johnson",
      preferredName: "Em",
      appointmentDate: "2025-04-05",
      appointmentTime: "10:15:00"
    }
  ];
   // Toggle this to see different examples
   //const appointments = familyAppointmentData; // or singlePatientData
    // const appointments = singlePatientData
  const [clinicData, setClinicData] = useState({
    clinicName: "Delta Eye Clinic",
    primaryColor: "#E3F2FD",
    secondaryColor: "#00796B",
    logo: "https://www.eyeconx.net/clinic/templates/logos/delta_eye_logo.png",
    address: "123 Main Street, Cityville, ST 12345",
    phone: "(123) 456-7890",
    fax: "(123) 456-7899",
    backgroundImage: "https://source.unsplash.com/1600x900/?medical,clinic", // Sample background image
  });
  const location = useLocation(); // Get full URL details.
  // Parse query parameters
  const searchParams = new URLSearchParams(location.search);
  const familyAppointment = searchParams.get("familyAppt");
  const ptId = searchParams.get("patientIds");
  const aptId = searchParams.get("aptIds");
  useEffect(() => {
    const demoData = {
      clinicName: "Delta Eye Clinic",
      primaryColor: "#E3F2FD",
      secondaryColor: "#00796B",
      logo: "https://www.eyeconx.net/clinic/templates/logos/delta_eye_logo.png",
      address: "123 Main Street, Cityville, ST 12345",
      phone: "(123) 456-7890",
      fax: "(123) 456-7899",
      backgroundImage: "https://source.unsplash.com/1600x900/?medical,clinic", // Sample background image
    };
    setClinicData(demoData);
   
    if(familyAppointment === 'true'){
        console.log("familyAppointment", familyAppointment);
        setAppointments(familyAppointmentData);
    }else{
        setAppointments(singlePatientData);
    
    }
    // Simulate API call
    /*fetch("/api/clinic-theme") // Replace with actual API endpoint
                   .then((res) => res.json())
                   .then((data) => setClinicData(data))
                   .catch((err) => console.error("Error fetching clinic data:", err));*/
  }, []);
  const [calendarSaved, setCalendarSaved] = useState(false);

  // Function to handle saving appointment to calendar
  const saveToCalendar = () => {
    // In a real app, this would generate an .ics file or open calendar integration
    console.log('Saving appointment to calendar');
    setCalendarSaved(true);
    
    // Reset the saved status after 3 seconds for demo purposes
    setTimeout(() => setCalendarSaved(false), 3000);
  };

  // Format date for display
  const formatDate = (dateString) => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // Format time for display
  const formatTime = (timeString) => {
    const options = { hour: 'numeric', minute: 'numeric', hour12: true };
    return new Date(`2000-01-01T${timeString}`).toLocaleTimeString(undefined, options);
  };

  // Check if this is a family appointment (multiple patients)
  const isFamily = familyAppointment === 'true'? true: false;

  return (
    <>
      <Box
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          padding: 3,
        }}
      >
        {clinicData && <TopHeader clinicData={clinicData} />}
        {/* Form Section */}
        <Slide direction="up" in={true} mountOnEnter unmountOnExit>
          <Paper
            elevation={4}
            sx={{
              padding: 4,
              maxWidth: "md",
              width: "100%",
              borderRadius: 3,
              textAlign: "center",
              backgroundColor: "#fff",
              boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)",
              marginTop: { xs: 5, md: 14 },
            }}
          >
           {/* Header */}
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            marginBottom: 3,
            backgroundColor: '#f5f5f5',
            padding: 2,
            borderRadius: 1
          }}
        >
          <EventAvailable color={clinicData.secondaryColor} sx={{ fontSize: 36, marginRight: 2, color: clinicData.secondaryColor }} />
          <Typography variant="h4" component="h1" color={clinicData.secondaryColor}>
            Appointment Confirmed
          </Typography>
        </Box>

        <Box sx={{ marginBottom: 2, alignItems:'center', justifyContent:'center', display:'flex', flexDirection:'column' }} >
          <Typography variant="h6" component="h2" gutterBottom>
            {isFamily ? (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <People sx={{ marginRight: 1, color: clinicData.secondaryColor }} />
                Family Appointment
              </Box>
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Person  sx={{ marginRight: 1,color: clinicData.secondaryColor }} />
                Patient Appointment
              </Box>
            )}
          </Typography>
          
          {/* Appointment Date and Time (same for all family members) */}
          
          <List dense>
            <ListItem>
              <ListItemIcon>
                <CalendarMonth sx={{color: clinicData.secondaryColor}} />
              </ListItemIcon>
              <ListItemText 
                primary="Appointment Date" 
                secondary={formatDate(appointments[0].appointmentDate)} 
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <AccessTime sx={{color: clinicData.secondaryColor}} />
              </ListItemIcon>
              <ListItemText 
                primary="Appointment Time" 
                secondary={ formatTime(appointments[0].appointmentTime)} 
              />
            </ListItem>
          </List>
         
        </Box>

        {/* Save to Calendar Button */}
        <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: 3 }}>
          <Button 
            variant="contained" 
            
            startIcon={calendarSaved ? <Check /> : <Save />}
            onClick={saveToCalendar}
            disabled={calendarSaved}
            sx={{
              backgroundColor: clinicData.secondaryColor,
              color: '#fff',
              '&:hover': {
                backgroundColor: clinicData.secondaryColor,
                opacity: 0.9,
              },
            }}
          >
            {calendarSaved ? 'Saved to Calendar' : 'Save to Calendar'}
          </Button>
        </Box>

        <Divider sx={{ marginBottom: 3 }} />

        {/* Patient(s) Information */}
        <Typography variant="h6" component="h2" gutterBottom>
          Patient Information
        </Typography>
        
        {/* Using Grid2 instead of the older Grid component */}
        <Grid container spacing={2} sx={{ justifyContent:'center'}} >
          {appointments.map((appointment, index) => (
            <Grid xs={12} md={isFamily ? 6 : 12} key={index}>
              <Card variant="outlined" sx={{ height: '100%' }}>
                <CardContent>
                  {isFamily && (
                    <Chip 
                      label={`Patient ${index + 1}`} 
                      
                      size="small" 
                      sx={{ marginBottom: 1,color: clinicData.secondaryColor }} 
                    />
                  )}
                  
                  <Typography variant="subtitle1" fontWeight="bold">
                    {appointment.firstName} {appointment.lastName}
                  </Typography>
                  
                  {appointment.preferredName && (
                    <Typography variant="body2" color="text.secondary">
                      Preferred name: {appointment.preferredName}
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
          </Paper>
        </Slide>
      </Box>
    </>
  );
}

// Sample data for demonstration
const AppointmentConfirmationDemo = () => {
    // Example data - single patient
    const singlePatientData = [
      {
        firstName: "John",
        lastName: "Smith",
        preferredName: "Johnny",
        appointmentDate: "2025-04-02",
        appointmentTime: "14:30:00"
      }
    ];
  
    // Example data - family appointment
    const familyAppointmentData = [
      {
        firstName: "Michael",
        lastName: "Johnson",
        preferredName: "Mike",
        appointmentDate: "2025-04-05",
        appointmentTime: "10:15:00"
      },
      {
        firstName: "Sarah",
        lastName: "Johnson",
        preferredName: "",
        appointmentDate: "2025-04-05",
        appointmentTime: "10:15:00"
      },
      {
        firstName: "Emma",
        lastName: "Johnson",
        preferredName: "Em",
        appointmentDate: "2025-04-05",
        appointmentTime: "10:15:00"
      }
    ];
  
    // Toggle this to see different examples
    const appointmentData = familyAppointmentData; // or singlePatientData
    
    return <Appointments appointments={appointmentData} />;
  };
  
export default Appointments;
